module.exports = __webpack_public_path__ + "static/media/memphis-grizzlies.0f27f10a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/data/svg/memphis-grizzlies.svg
// module id = 234
// module chunks = 0